import Url from "../LocalService";
import { CliID } from "../LocalService";
import { useCookie } from "../LocalService";
import { useGeolocation } from "./useGeolocation";

export const useFetchServices = () =>{
    let cookie = useCookie();
    let geolocation = useGeolocation();
    let _id = 0;
    let _servies = [];

    const executeService = ({method, endpoint, body}) => {
        let data = {
            seguranca: {
                CliID: CliID,
                AppAuthOB: cookie.get("AppAuthOB"),
                Geolocation: geolocation,
            },
            ...body,
        };

        return fetch(Url + endpoint, {
                method: "POST",
                headers: {
                "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            })
            .then((res) => {
                return res.json();
            });
    };

    return{
        executeService,
    };

};